import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from "sonner";
/**
 * The toast host (block 03, override 5).
 *
 * 00e left the toast slot empty because shadcn removed `toast` from its
 * registry and `sonner` brings a `next-themes` peer. **That peer is not taken
 * on here.** shadcn's generated wrapper calls `useTheme()` to hand sonner a
 * `theme` string, but this app has no theme provider at all: dark mode is the
 * `.dark` class variant generated by `@nook/config`, and nothing sets it yet.
 * Installing a theming library to read a value nobody writes would be adding a
 * dependency to answer a question the app is not asking.
 *
 * Instead the toast is painted from the same custom properties every other
 * component resolves against, so it follows the theme by construction and will
 * keep following it the day a `.dark` toggle lands.
 */
function Toaster(props) {
    return (_jsx(Sonner, { className: "toaster group font-sans", style: {
            "--normal-bg": "var(--popover)",
            "--normal-text": "var(--popover-foreground)",
            "--normal-border": "var(--border)",
            "--border-radius": "var(--radius)",
        }, ...props }));
}
export { Toaster };
//# sourceMappingURL=sonner.js.map